module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-oben_red-3898bf5c0e92e6bace3225a73fe6c208.svg";